import * as CONST from '../../constants';

const INITIAL_STATE = { loading: true, subscription: null, error: null };

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CONST.SUBSCRIPTION_EDIT_ADDRESS_REQUEST:
      return { ...INITIAL_STATE, loading: true };
    case CONST.SUBSCRIPTION_EDIT_ADDRESS_SUCCESS:
      return { ...INITIAL_STATE, loading: false, subscription: action.subscription };
    case CONST.SUBSCRIPTION_EDIT_ADDRESS_ERROR:
      return { ...INITIAL_STATE, loading: false, error: action.error };
    case CONST.CLOSE_MODAL:
      return { ...INITIAL_STATE, loading: false, error: null, subscription: null };
    default:
      return state;
  }
};
